<template>
  <div>
    <el-select
      v-if="type === 'select'"
      v-model="refVendorId"
      style="width:100%"
      placeholder="请选择物流公司"
      @change="handleChange">
      <el-option
        v-for="item in vendorNames"
        :key="item.expressId"
        :label="item.expressName + '-' +item.expressTempletName"
        :value="item.expressId">
      </el-option>
    </el-select>
    <span v-else>{{ expressName }}</span>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'EntLogisticsSelect',
  props: {
    callback: Function,
    type: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      // vendorNames: []
    }
  },
  computed: {
    refVendorId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    ...mapState({
      userInfo: state => state.account.userInfo,
      vendorNames: state => state.account.expressList
    }),
    info() {
      return this.vendorNames.find(i => i.expressId === this.refVendorId) || {}
    },
    expressName() {
      const item = this.vendorNames.find(i => i.expressId === this.refVendorId) || {}
      return item.expressTempletName
    }
  },
  mounted() {
    // this.getEntList()
    this.$store.dispatch('account/getexpresses')
  },
  methods: {
    handleChange(val) {
      const item = this.vendorNames.find(i => i.expressId === val) || {}
      this.callback && this.callback(item)
    },
    getEntList() {
      this.$store.dispatch('vendor/getexpresses', {
        payload: this.option,
        success: (res) => {
          this.vendorNames = res.data.records
        },
        fail: () => {
          this.vendorNames = []
        }
      })
    }
  }
}
</script>
